module.exports = __webpack_public_path__ + "img/bg.dd564d20.jpg";